import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationClinicUpdatePutBody,
  IConfigurationClinicUpdateResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationClinicUpdateAPI = () => {
  const [updatedClinicId, setUpdatedClinicId] = useState<string>("");
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (clinicData: IConfigurationClinicUpdatePutBody, clinicId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!clinicData) {
          return;
        }
        await axios
          .put(`${CONFIGURATION_APIS?.CLINIC_UPDATE?.baseURL}${clinicId}/`, clinicData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationClinicUpdateResponse>) => {
            if (res.data.status === true) {
              setUpdatedClinicId(res.data.data.clinic_id);
            } else {
              setUpdatedClinicId("");
              toast.error("Error while updating clinic details.");
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching clinic details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );
  return { updatedClinicId, execute };
};
